module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/categoryIcons/nfl/icons_passing_yds/green-a08269258a31c474d563b3de1af669a2.svg";